import { render, staticRenderFns } from "./refundDetails.vue?vue&type=template&id=b4151564&scoped=true"
import script from "./refundDetails.vue?vue&type=script&lang=js"
export * from "./refundDetails.vue?vue&type=script&lang=js"
import style0 from "./refundDetails.vue?vue&type=style&index=0&id=b4151564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4151564",
  null
  
)

export default component.exports